import { useState, useRef } from 'react';
import styled from 'styled-components';

export default function LinkoPayInput(props) {
	const { column, value, setValue, width, disabled, placeholder } = props;

	const [changed, setChanged] = useState(false);

	const inputRef = useRef();

	function handleClick(e) {

	}

	function handleChange(e) {
		setValue(e.target.value);
		setChanged(true);
	}

	function handleFocus(e) {
		if (changed) {
			// do nothing
		} else {
			setValue("");
		}
	}

	function handleBlur(e) {
		if (value === "") {
			// setDefaultPlaceholder(placeholder);
			// inputRef.current.style.borderColor = '#FF3131';
		} 
		else {
			// inputRef.current.style.borderColor = '#E8E8E8';
		}
	}

  return (
    <TopLevelWrapper>
      <Column>{column}</Column>
      <Input
        ref={inputRef}
        disabled={disabled}
        value={value}
				width={width}
        placeholder={placeholder}
        onClick={handleClick}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const Column = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;

  &:hover {
    cursor: pointer;
  } 
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	
	margin-top: 8px;
	padding: 0 15px 0 15px;

	outline: none;
	border: 1px solid #CBCBCB;
	border-radius: 8px;
	color: #000000;

	width: ${props => props.width}px;
	height: 30px;

	::placeholder {
		color: #CBCBCB;
	}

  &:disabled {
    background-color: #FFFFFF;
  }
`;